import actionTypes from './actionTypes';

const initialState = {
  createDriverConfirmation: false,
  createDriverConfirmationMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CONFIRM_CREATION:
      return {
        ...state,
        createDriverConfirmation: true,
        createDriverConfirmationMessage: action.payload.userId,
      };
    case actionTypes.AFTER_CONFIRM_CREATION:
      return {
        ...state,
        createDriverConfirmation: false,
        createDriverConfirmationMessage: null,
      };

    default:
      return state;
  }
};
